import { LegalDocument, LegalLink, LegalP, LegalSection, LegalUl } from "../../components/LegalDocument"

export default function Privacy() {
    return (
        <LegalDocument title="Политика конфиденциальности">
            <LegalSection title="1. Общие положения">
                <LegalP>
                    1.1. Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки и
                    защиты персональных данных физических лиц (далее — «Пользователи»), предоставляемых Обществу с
                    ограниченной ответственностью «Империя игр» (ООО «Империя игр», ИНН 7452030395, ОГРН
                    1027403888126) при использовании онлайн-сервиса «Мягкий кинотеатр», включая веб-сайт{" "}
                    <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink> и мобильное приложение «Мягкий
                    кинотеатр» (далее — «Сервис»).
                </LegalP>
                <LegalP>
                    1.2. Политика разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О
                    персональных данных» и иными действующими нормативными правовыми актами Российской Федерации.
                    Подробное{" "}
                    <LegalLink to="/personal-data">Положение об обработке персональных данных</LegalLink> размещено
                    отдельно.
                </LegalP>
                <LegalP>
                    1.3. Используя Сервис, Пользователь выражает согласие с условиями данной Политики. Согласие на
                    обработку персональных данных оформляется отдельно в соответствии с требованиями ст. 9 Закона №
                    152-ФЗ (с 1 сентября 2025 года).
                </LegalP>
            </LegalSection>

            <LegalSection title="2. Персональные данные, обрабатываемые в Сервисе">
                <LegalP>2.1. В рамках работы Сервиса могут обрабатываться следующие персональные данные:</LegalP>
                <LegalUl
                    items={[
                        <>
                            <strong className="text-white/80">Номер мобильного телефона</strong> — используется для
                            регистрации, авторизации, восстановления доступа и идентификации;
                        </>,
                        <>
                            <strong className="text-white/80">Фамилия, имя, отчество (ФИО)</strong> — используются для
                            персонализации сервисов;
                        </>,
                        <>
                            <strong className="text-white/80">Адрес электронной почты</strong> — используется для
                            направления уведомлений, подтверждений операций, технической поддержки;
                        </>,
                        <>
                            <strong className="text-white/80">Данные о действиях на сайте и в приложении</strong> —
                            используются для аналитики и улучшения пользовательского опыта.
                        </>,
                    ]}
                />
                <LegalP>
                    2.2. При использовании базового функционала (например, просмотр расписания или покупка билета без
                    создания личного кабинета) регистрация не требуется.
                </LegalP>
                <LegalP>
                    2.3. Доступ к бонусной программе и расширенному функционалу Сервиса (включая историю заказов,
                    накопление и использование бонусов) возможен только после регистрации и создания Аккаунта.
                </LegalP>
            </LegalSection>

            <LegalSection title="3. Цели обработки персональных данных">
                <LegalP>3.1. Персональные данные обрабатываются исключительно в следующих целях:</LegalP>
                <LegalUl
                    items={[
                        "регистрации и идентификации Пользователя в системе;",
                        "предоставления доступа к функциям Личного кабинета и бонусной программе;",
                        "направления технических уведомлений, подтверждений заказов, информации о статусе билетов;",
                        "соблюдения требований законодательства Российской Федерации, включая фискальный учёт.",
                    ]}
                />
                <LegalP>3.2. Оператор не осуществляет массовую рассылку рекламных материалов.</LegalP>
                <LegalP>
                    3.3. Пользователь может в любой момент запросить удаление своего аккаунта и прекращение обработки
                    персональных данных (за исключением данных, подлежащих хранению по закону — например, фискальные
                    документы).
                </LegalP>
            </LegalSection>

            <LegalSection title="4. Передача и хранение персональных данных">
                <LegalP>4.1. Оператор не передаёт персональные данные третьим лицам, за исключением следующих случаев:</LegalP>
                <LegalUl
                    items={[
                        <>
                            передача оператору фискальных данных — ООО «Первый ОФД» — для формирования и отправки
                            электронных чеков в соответствии с 54-ФЗ;
                        </>,
                        "предоставление информации уполномоченным государственным органам — по основаниям, предусмотренным законодательством;",
                        "передача иным лицам — только с согласия Пользователя.",
                    ]}
                />
                <LegalP>
                    4.2. Персональные данные обрабатываются и хранятся в течение срока действия Аккаунта либо в течение
                    иного периода, предусмотренного законодательством РФ.
                </LegalP>
                <LegalP>
                    4.3. Оператор не осуществляет обработку и не хранит данные банковских карт, включая номера карт,
                    CVV-коды и иные платёжные реквизиты. Все операции оплаты билетов выполняются через сертифицированные
                    платёжные системы, действующие независимо от Оператора.
                </LegalP>
            </LegalSection>

            <LegalSection title="5. Защита персональных данных">
                <LegalP>
                    5.1. Оператор принимает все необходимые организационные, технические и правовые меры для обеспечения
                    защиты персональных данных от несанкционированного доступа, изменения, раскрытия, уничтожения и
                    иных неправомерных действий.
                </LegalP>
                <LegalP>
                    5.2. Меры безопасности соответствуют требованиям законодательства Российской Федерации в сфере
                    персональных данных.
                </LegalP>
            </LegalSection>

            <LegalSection title="6. Права Пользователя">
                <LegalP>6.1. Пользователь имеет право:</LegalP>
                <LegalUl
                    items={[
                        "получить информацию о своих персональных данных, обрабатываемых Оператором;",
                        "требовать уточнения, блокировки или удаления данных;",
                        "отозвать согласие на обработку персональных данных;",
                        "подать обращение или жалобу по вопросам обработки персональных данных.",
                    ]}
                />
                <LegalP>
                    6.2. Для реализации своих прав Пользователь может направить письменное обращение по контактной
                    информации, указанной в разделе 7 настоящей Политики.
                </LegalP>
                <LegalP>
                    6.3. Удаление Аккаунта влечёт прекращение доступа к бонусной программе и удаление связанных
                    персональных данных (за исключением данных, подлежащих обязательному хранению по закону).
                </LegalP>
            </LegalSection>

            <LegalSection title="7. Контактная информация Оператора">
                <LegalP>
                    <strong className="text-white/80">Оператор:</strong>
                    <br />
                    ООО «Империя игр»
                    <br />
                    ИНН/КПП: 7452030395 / 745301001
                    <br />
                    ОГРН: 1027403888126
                    <br />
                    Юридический адрес: 454091, Челябинская область, г. Челябинск, Свердловский пр-кт, д. 51а
                    <br />
                    Сайт: <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink>
                    <br />
                    Telegram: <LegalLink href="https://t.me/comfortkinohelp_bot">t.me/comfortkinohelp_bot</LegalLink>
                </LegalP>
            </LegalSection>

            <LegalSection id="cookies" title="8. Файлы cookie и аналогичные технологии">
                <LegalP>
                    8.1. Сервис использует файлы cookie и аналогичные технологии (localStorage) — небольшие файлы,
                    сохраняемые на устройстве Пользователя. Они необходимы для корректной работы сайта и не используются
                    для отслеживания Пользователя за пределами Сервиса.
                </LegalP>
                <LegalP>8.2. Файлы cookie используются в следующих целях:</LegalP>
                <LegalUl
                    items={[
                        "поддержание авторизации Пользователя в Личном кабинете;",
                        "сохранение выбранного города и кинотеатра;",
                        "сохранение черновика заказа (выбранных мест) при оформлении покупки;",
                        "запоминание показанных Пользователю уведомлений и настроек интерфейса;",
                        "анализ работы Сервиса и улучшение пользовательского опыта.",
                    ]}
                />
                <LegalP>
                    8.3. Продолжая использовать Сервис, Пользователь соглашается с использованием файлов cookie.
                    Пользователь может удалить сохранённые файлы cookie и запретить их сохранение в настройках браузера,
                    однако в этом случае часть функций Сервиса (включая авторизацию и покупку билетов) может стать
                    недоступной.
                </LegalP>
            </LegalSection>

            <LegalSection title="9. Изменение Политики">
                <LegalP>9.1. Оператор вправе вносить изменения в настоящую Политику в любое время.</LegalP>
                <LegalP>9.2. Новая редакция вступает в силу с момента её размещения в Сервисе.</LegalP>
                <LegalP>
                    9.3. Пользователю рекомендуется регулярно проверять текущую версию Политики на сайте{" "}
                    <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink>.
                </LegalP>
            </LegalSection>
        </LegalDocument>
    )
}
